import { MetaTagsHelper } from 'app/utils/metaTags/metaTagsHelper';
import { Component, TemplateRef, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { NavigationService } from 'app/utils/navigation/navigation.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
import { AppConfigService } from 'app/utils/appconfig/app-config.service';

@Component({
    moduleId: module.id,
    selector: 'next-login',
    templateUrl: './selfcare-login.component.html',
    styleUrls: ['./selfcare-login.component.less'],
})
export class SelfcareLoginComponent implements OnInit, OnDestroy {
    bsModalRef: BsModalRef;
    failedGetTasksAttempts = 0;
    redirectRelativeUrl: string;
    useMitId: boolean;

    subscriptions: Subscription[] = [];

    constructor(
        private router: Router,
        private navService: NavigationService,
        private modalService: BsModalService,
        private metaTagsHelper: MetaTagsHelper,
        private appConfigService: AppConfigService
    ) {
        this.metaTagsHelper.setTitleAndMetaTags('META.SELFCARE_LOGIN');
    }

    openModal(template: TemplateRef<any>) {
        this.bsModalRef = this.modalService.show(template);
    }

    ngOnInit() {
        this.useMitId = this.appConfigService.appConfig.useMitId;

        this.redirectRelativeUrl = this.navService.getUrl('selfcare-landing');
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach((s) => s.unsubscribe());
    }

    nemIdLoginComplete() {
        this.router.navigateByUrl(this.redirectRelativeUrl);
    }
}
